/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { SimpleAction } from './simple-action';
import { ColumnManager } from '../../manager/table-manager/column-manager';

export class ColumnAction extends SimpleAction<any> {
  public column: ColumnManager;

  override get check(): boolean {
    return this.column.showOnTable;
  }

  override set check(value: boolean) {
    this.column.showOnTable = value;
  }

  constructor(column: ColumnManager, check: boolean) {
    super(column.property.id, '', null, column.text);
    this.column = column;
    this._check = check;
  }

  public override toString(): string {
    return this.column.text;
  }
}
